export default "__VITE_ASSET__DdWgosnS__"